import { render } from "./PcHome.vue?vue&type=template&id=21873ea8&scoped=true"
import script from "./PcHome.vue?vue&type=script&lang=js"
export * from "./PcHome.vue?vue&type=script&lang=js"

import "./PcHome.vue?vue&type=style&index=0&id=21873ea8&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1e77ff55b92932984816aac78a22ff52/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21873ea8"]])

export default __exports__